//
//
//
//
//
//
//
//
//
//
//

import Base from '../../libs/base'

export default {
  name: 'x-progress',
  mixins: [Base],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel () {
      this.$emit('on-cancel')
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/components/x-progress/index.vue